import { Module } from '@nu-art/ts-common';
import { ApiDef_ActionProcessing } from '@nu-art/thunderstorm-shared/action-processor/index';
import { apiWithBody, apiWithQuery } from '../../core/typed-api.js';
class ModuleFE_ActionProcessor_Class extends Module {
    vv1;
    constructor() {
        super();
        this.vv1 = {
            execute: apiWithBody(ApiDef_ActionProcessing.vv1.execute),
            list: apiWithQuery(ApiDef_ActionProcessing.vv1.list),
        };
    }
}
export const ModuleFE_ActionProcessor = new ModuleFE_ActionProcessor_Class();
//# sourceMappingURL=ModuleFE_ActionProcessor.js.map